import { TypedDocumentNode, gql } from '@apollo/client';

import { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { withFragments } from '@sorare/core/src/gql';

import { ComputeCardsToDisplay_anyCard } from './__generated__/utils.graphql';

export const computeCardsToDisplay = withFragments(
  <T extends ComputeCardsToDisplay_anyCard>(
    cards: T[],
    blockchainCards: T[]
  ) => {
    const hasBlockchainCards = !!blockchainCards.length;
    const notBlockchainCards = cards.filter(card =>
      [Rarity.common, Rarity.custom_series].includes(card.rarityTyped)
    );
    if (hasBlockchainCards) {
      return [...blockchainCards, ...notBlockchainCards];
    }
    return cards;
  },
  {
    anyCard: gql`
      fragment ComputeCardsToDisplay_anyCard on AnyCardInterface {
        slug
        rarityTyped
        pictureUrl
      }
    ` as TypedDocumentNode<ComputeCardsToDisplay_anyCard>,
  }
);
